/**
 * Licensed Materials - Property of IBM
 * IBM Watson Analytics (C) Copyright IBM Corp.  2017, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'../../lib/@waca/core-client/js/core-client/ui/core/View',
	'../../lib/@waca/core-client/js/core-client/utils/BrowserUtils',
	'underscore'
], function(View, BrowserUtils, _) {


	var ActiveFilterIndicatorView = View.extend([], {

		tagName: 'div',

		className: 'filterAppliedIndicator',

		/**
		 * Constructor
		 *
		 * @param {object} options
		 * @param {object} options.scopes - an object containing the various scopes to be queried
		 * @param {object} options.pageContextAPI - api to query page context about filters
		 *
		 */
		init: function(options) {
			ActiveFilterIndicatorView.inherited('init', this, arguments);

			this.scopesObject = options.scopes;
			this.pageContextAPI = options.pageContextAPI;
			this._animate = true;
			if (options.animate !== undefined) {
				this._animate = options.animate;
			}
			if (BrowserUtils.isIE() && !BrowserUtils.isIEEdge()) {
				this.$el.addClass('ie');
			}
		},

		/**
		 * Method to show/hide the filter count badge
		 * The indicator will only be shown if the count is greater than zero
		 * and overrides a 'true' parameter
		 *
		 * @param {boolean} display - TRUE to show and FALSE to hide
		 */
		show: function(display) {
			if(display && this.getActiveCount() > 0) {

				this.setCount(this.getActiveCount());

				if(this.$el.parent().is(':visible') && this._animate) {
					this.$el.fadeIn(); //fadeIn doesn't work if not visible
				} else {
					this.$el.show();
				}
			} else {
				if(this.$el.parent().is(':visible') && this._animate) {
					this.$el.fadeOut(); //fadeOut doesn't work if not visible
				} else {
					this.$el.hide();
				}
			}
		},

		/**
		 * @returns the combined total of active filters across the global and current tab scopes
		 */
		getActiveCount: function() {
			var numFilters = 0;
			var scopes = _.values(this.scopesObject);

			scopes.forEach(function(entry) {
				numFilters += _.filter(this.pageContextAPI.getPageContextItems({ scope: entry, origin: 'filter' }), function(item) {
					return item.getValueCount() > 0 || (item.getIsModeledFilter && item.getIsModeledFilter());
				}).length;
			}, this);
			return numFilters;
		},

		/**
		 * Sets the filter indicator to the given count value
		 * If count of zero, immediately hides the indicator
		 * If over 99 active filters are present, instead displays '99+', and css is adjusted accordingly
		 * @param {int} count - the number of active filters to be displayed
		 */
		setCount: function(count) {
			if(count === 0) {
				if (this._animate) {
					this.$el.fadeOut('default', function() { //default isn't a correct string, will default to 400 milliseconds
						this.$el.text(count);
					}.bind(this));
				} else {
					this.$el.hide();
					this.$el.text(count);
				}
				return;
			}
			if(count > 99) {
				count = '99+';
			}
			this.$el.text(count);
		},

		/**
		 * Sets the scope key to the specified value
		 *
		 * @param {string} key - the key for the scope. Currently either 'globalScope' or 'tabScope'
		 * @param {string} value - the id of the scope being set
		 */
		setScope: function(key, value) {
			this.scopesObject[key] = value;
		},

		/**
		 * Returns the DOM node for use
		 */
		getNode: function() {
			return this.$el;
		},

		remove: function () {
			ActiveFilterIndicatorView.inherited('remove', this, arguments);
			this.scopesObject = null;
			this.pageContextAPI = null;
		}
	});
	return ActiveFilterIndicatorView;
});
